
import React from "react";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface UserCardProps {
  id: string;
  avatarUrl?: string;
  fullName?: string;
  username?: string;
}

const UserCard = ({ id, avatarUrl, fullName, username }: UserCardProps) => {
  // Get initials from name
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(part => part[0])
      .join('')
      .toUpperCase() || 'U';
  };

  return (
    <div key={id} className="flex items-center justify-between p-3 bg-background rounded-lg border">
      <div className="flex items-center gap-3">
        <Avatar>
          <AvatarImage src={avatarUrl} alt={fullName || username} />
          <AvatarFallback>
            {getInitials(fullName || username || "")}
          </AvatarFallback>
        </Avatar>
        <div>
          <p className="font-medium">{fullName || "Anonymous User"}</p>
          <p className="text-sm text-muted-foreground">@{username || "username"}</p>
        </div>
      </div>
      <Button variant="outline" size="sm">View Profile</Button>
    </div>
  );
};

export default UserCard;
